import { AlphaMIcon } from './AlphaMIcon';

/**
 * author: GreenTurtwig
 * id 31B62839-D838-41FE-86B8-313070BBB0A9
 * name alpha-m
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-m.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetMIcon = AlphaMIcon;
export default AlphabetMIcon